"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { GameControlsExpand } from "@workspace/frontend-ui";
import type { FC } from "react";

const ExpandButton: FC = () => {
  const { isDesktop, isExpanded, toggleExpand, t } = useGamePageData();

  if (!isDesktop) return null;

  const label = isExpanded
    ? t("game.controls.expand.collapse", "Collapse the game")
    : t("game.controls.expand.expand", "Expand the game");

  return (
    <GameControlsExpand
      data-testid="expand-button"
      aria-label={label}
      isExpanded={isExpanded}
      onClick={toggleExpand}
    />
  );
};

export default ExpandButton;
